import Vue from 'vue';
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { i18n } from '@/plugins/i18n.js';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

extend('url', {
    validate: (value) => {
        const pattern = new RegExp(
            '^(https?:\\/\\/)' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$', // fragment locator
            'i'
        );

        return pattern.test(value);
    },
    message: 'The {_field_} must be a valid URL',
});

Object.keys(rules).forEach((rule) => {
    extend(rule, rules[rule]);
});

localize('en', {
    code: 'en',
    messages: {
        required: i18n.t('validation.required', { attribute: '{_field_}' }),
        numeric: i18n.t('validation.numeric', { attribute: '{_field_}' }),
        min_value: i18n.t('validation.min.numeric', {
            attribute: '{_field_}',
            min: '{min}',
        }),
        max_value: i18n.t('validation.max.numeric', {
            attribute: '{_field_}',
            max: '{max}',
        }),
    },
});
